export default "__VITE_ASSET__9Onb0rI5__"